import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../service/common/notification/notification.service';
import { ConfirmDialogService } from '../../service/common/confirm-dialog/confirm-dialog.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResourceUserService } from '../../service/settings/resource-user.service';
import { ResourceUser } from '../../domain/model/resource-user';

@Component({
    selector: 'tnb-settings-user-detail',
    templateUrl: './settings-user-detail.component.html',
    styleUrls: [
        './settings-user-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsUserDetailComponent implements OnInit {
    private userService = inject(ResourceUserService);
    private activatedRoute = inject(ActivatedRoute);
    private notificationService = inject(NotificationService);
    private confirmDialogService = inject(ConfirmDialogService);
    westnetzSidenavService = inject(WestnetzSidenavService);
    private formBuilder = inject(FormBuilder);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public createNew = false;
    public currentUsername?: string = null;
    public userForm: FormGroup;
    public passwordHide = true;

    constructor() {
        const formBuilder = this.formBuilder;

        this.userForm = formBuilder.group({
            username: [
                '',
                [
                    Validators.required,
                ],
            ],
            password: [
                '',
                [
                    Validators.required,
                ],
            ],
            enabled: [
                true,
                [
                    Validators.required,
                ],
            ],
            allowRead: [
                false,
                [
                    Validators.required,
                ],
            ],
            allowWrite: [
                false,
                [
                    Validators.required,
                ],
            ],
        });
    }

    public get f(): { [key: string]: AbstractControl } {
        return this.userForm.controls;
    }

    ngOnInit() {
        const userName = this.activatedRoute.snapshot.queryParams['username'];
        this.createNew = userName == null || userName === '';
        if (!this.createNew) {
            this.userForm.controls.username.disable();
            this.userForm.controls.password.clearValidators();
            this.userService.getUserByUsername(userName)
                .pipe(take(1))
                .subscribe((user: ResourceUser) => {
                    this.userForm.patchValue(user);
                    this.currentUsername = userName;
                    this.changeDetectorRef.markForCheck();
                });
        }
    }

    saveUser() {
        if (this.userForm.invalid) {
            this.userForm.setErrors({ 'invalidForm': true });
            return;
        }

        if (this.createNew) {
            this.userService.saveUser(this.userForm.getRawValue()).subscribe({
                next: () => {
                    this.westnetzSidenavService.closeRightnav();
                    this.notificationService.success('Der Benutzer wurde erfolgreich angelegt');
                },
                error: () => {
                    this.notificationService.failure('Der Benutzer konnte nicht gespeichert werden');
                },
            });
        } else {
            this.userService.updateUser(this.currentUsername, this.userForm.getRawValue()).subscribe({
                next: () => {
                    this.westnetzSidenavService.closeRightnav();
                    this.notificationService.success('Der Benutzer wurde erfolgreich geupdated');
                },
                error: () => {
                    this.notificationService.failure('Der Benutzer konnte nicht geupdated werden');
                },
            });
        }
    }

    async deleteUser() {
        if (!this.createNew && await this.confirmDialogService.confirm(
            'Sind Sie sicher, dass Sie den Benutzer enfernen möchten?',
            'Benutzer entfernen!',
            'warn',
            'Entfernen',
            'Abbrechen',
            'innogy_picto_bin_c-check',
        )) {
            this.userService.deleteUser(this.currentUsername).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Der Benutzer wurde entfernt');
            });
        }
    }
}
